var power = "https://shopfront-cdn.tekoapis.com/static/8c661c8671413d6f.svg";

export { power as default };
